{
  "it": {
    "empty": {
      "headlines": {
        "default": "Non c'è niente da vedere qui...",
        "forName": "Nessun %{name} trovato",
        "hangar": "Il tuo hangar è vuoto",
        "wishlist": "La tua lista dei desideri è vuota",
        "features": "Nessuna funzione disponibile",
        "fleetFeatures": "Nessuna funzionalità della flotta disponibile",
        "imports": "Nessuna importazione trovata",
        "transfers": "Nessun trasferimento"
      },
      "actions": {
        "reset": "Resetta i filtri/pagine",
        "resetPage": "Vai alla prima pagina"
      },
      "texts": {
        "info": "Non abbiamo trovato alcun record.",
        "query": "Sembra che tu abbia alcuni filtri attivi o visitati una pagina senza alcun record."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "Attualmente non sono disponibili funzioni self-service. Torna più tardi poiché vengono aggiunte regolarmente nuove funzioni.",
        "fleetFeatures": "Attualmente non ci sono funzionalità che una flotta può attivare da sé. Torna più tardi poiché vengono aggiunte regolarmente nuove funzioni."
      },
      "payouts": {
        "entries": "Ancora nessun movimento",
        "participants": "Ancora nessuno in questa spedizione",
        "transfers": "Chiudi per vedere chi paga chi",
        "tours": "Ancora nessuna spedizione"
      },
      "fleets": {
        "contracts": {
          "items": "Ancora nessuna merce. Aggiungi ciò che questo contratto richiede: vuoto non può essere pubblicato."
        },
        "events": {
          "upcoming": "Niente in programma",
          "past": "Non è ancora successo nulla",
          "archived": "Niente archiviato",
          "info": {
            "upcoming": "Crea un evento per riunire la flotta: scegli una data, aggiungi posti e lascia che i membri si iscrivano.",
            "past": "Un evento finisce qui una volta passato il suo orario di fine.",
            "archived": "Archiviare toglie un evento dalla lista senza eliminarlo."
          }
        },
        "missions": {
          "active": "Ancora nessuna missione",
          "archived": "Niente archiviato",
          "info": {
            "active": "Una missione è un piano riutilizzabile — squadre, navi e posti — da cui generi eventi.",
            "archived": "Archiviare toglie una missione dalla lista senza eliminarla."
          }
        }
      }
    }
  }
}
